module.exports = __webpack_public_path__ + "logo.f6f497fbaee31caaf758.png";


//////////////////
// WEBPACK FOOTER
// C:/Users/benge/Angular/my-first-app/src/assets/images/logo.png
// module id = ../../../../../src/assets/images/logo.png
// module chunks = main